var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76296 8L0.287897 4.77831C-0.0959078 4.42249 -0.095974 3.84553 0.287749 3.48963C0.671571 3.13372 1.29393 3.13361 1.67781 3.48946L3.76296 5.42237L9.32228 0.266935C9.70606 -0.0889606 10.3283 -0.0889811 10.7121 0.26689C11.0959 0.622789 11.096 1.19984 10.7122 1.55574L3.76296 8Z",
    fill: "#3DBF36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCheck);
export default __webpack_public_path__ + "static/media/new_check.83f296b3f0762d45ba30a7904cac093f.svg";
export { ForwardRef as ReactComponent };